import React from 'react';
import { MapPin, Mail, Phone, Clock, Facebook, Instagram, Linkedin, Twitter, Youtube } from 'lucide-react';
import Contact from '../components/Contact';
import { PageHero } from './AboutPage';
import { contact } from '../mock';

const ContactPage = () => {
  const offices = [
    { city: 'Headquarters', addr: contact.address, phone: contact.phone1 },
  ];
  return (
    <div>
      <PageHero title="Get in Touch" subtitle="We'd love to hear from you. Let's power your green journey together." />

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          <Info icon={Mail} title="Email Us" lines={[contact.email]} />
          <Info icon={Phone} title="Call Us" lines={[contact.phone1]} />
          <Info icon={Clock} title="Office Hours" lines={['Mon – Sat: 9am – 7pm', 'Support: 24/7']} />
        </div>
      </section>

      <Contact />

      <section className="py-20 bg-emerald-50/40">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0b1a1a] text-center">Our <span className="text-emerald-600">Headquarters</span></h2>
          <div className="mt-10 grid max-w-md mx-auto gap-6">
            {offices.map((o) => (
              <div key={o.city} className="bg-white rounded-3xl p-7 border border-slate-100 hover:shadow-xl hover:shadow-emerald-100 transition-shadow">
                <MapPin className="w-7 h-7 text-emerald-600" />
                <h3 className="mt-4 text-xl font-extrabold text-[#0b1a1a]">{o.city}</h3>
                <p className="mt-2 text-slate-600 text-sm">{o.addr}</p>
                <p className="mt-2 text-emerald-600 font-semibold text-sm">{o.phone}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 rounded-3xl overflow-hidden shadow-xl border border-emerald-100">
            <iframe title="Headquarters map" src="https://www.google.com/maps?q=SCO+15,+HSVP+Complex,+Sector+4-5,+Karnal+132001&output=embed" className="w-full h-[400px] border-0" />
          </div>
          <div className="mt-5 text-center">
            <a href={contact.mapUrl} target="_blank" rel="noreferrer" className="text-sm font-bold text-emerald-700 hover:text-emerald-900 underline underline-offset-4">Get directions to our headquarters</a>
          </div>
          <div className="mt-10 flex items-center justify-center gap-3">
            {[Facebook, Instagram, Linkedin, Twitter, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full bg-white hover:bg-emerald-500 hover:text-white text-emerald-700 grid place-items-center transition-colors shadow-sm">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

const Info = ({ icon: Icon, title, lines }) => (
  <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-3xl p-7 border border-emerald-100">
    <div className="w-12 h-12 rounded-2xl bg-emerald-500 grid place-items-center"><Icon className="w-6 h-6 text-white" /></div>
    <h3 className="mt-4 text-lg font-extrabold text-[#0b1a1a]">{title}</h3>
    {lines.map((l) => <p key={l} className="mt-1 text-slate-600 text-sm">{l}</p>)}
  </div>
);

export default ContactPage;
